import { jsx as t, jsxs as d, Fragment as c } from "react/jsx-runtime";
import { Skeleton as s } from "@acctglobal/skeleton";
import { memo as h } from "react";
import m from "./CustomQuantitySelector/index.js";
const p = ({
  hasUndQtd: i,
  decrease: r,
  increase: e,
  measurementUnit: o,
  isLeftDisabled: l,
  isRightDisabled: n,
  layout: a
}) => /* @__PURE__ */ t("div", { className: "input-add", "data-testid": "quantity-selector-container", children: o ? /* @__PURE__ */ d(c, { children: [
  !a && /* @__PURE__ */ t("div", { className: "product-add-text", children: /* @__PURE__ */ t("p", { children: "Produto adicionado" }) }),
  /* @__PURE__ */ t(
    m,
    {
      measureUnit: o,
      quantity: i,
      leftButtonProps: {
        onClick: r,
        disabled: l,
        icon: /* @__PURE__ */ t(
          "svg",
          {
            width: "13",
            height: "28",
            viewBox: "0 0 11 4",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ t(
              "path",
              {
                d: "M0.568324 3.336V0.767999H10.6243V3.336H0.568324Z",
                fill: "var(--color-main)"
              }
            )
          }
        )
      },
      rightButtonProps: {
        onClick: e,
        disabled: n,
        icon: /* @__PURE__ */ t(
          "svg",
          {
            width: "15",
            height: "28",
            viewBox: "0 0 13 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ t(
              "path",
              {
                d: "M0.952276 7.336V4.768H5.46428V0.615999H8.08028V4.768H12.5683V7.336H8.08028V11.488H5.46428V7.336H0.952276Z",
                fill: "var( --color-main)"
              }
            )
          }
        )
      }
    }
  )
] }) : /* @__PURE__ */ t(
  s,
  {
    width: 100,
    height: 40,
    backgroundColor: "var(--color-grayScale-faded)"
  }
) }), v = h(p);
export {
  v as default
};
